<div class="row col-12 p-0 m-0 empty-state-container main-page-section ">
  <div class="col-12 p-0">
    <div class="empty-state-section row">
      <div class="col-12">
        <div class="empty-state-content">
          <p class="title">No Data Found</p>
        </div>
      </div>
      <div class="col-12">
        <div class="empty-state-image">
          <img src="../../../../../../assets/images/error-page/empty-state.png" alt="empty state image" loading="lazy" />
        </div>
      </div>
    </div>
  </div>
</div>
